<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" :rules="formRules" ref="formData" label-width="140px">
        <el-row :span="24">
          <!-- 当班日期独立选择，表示本次班次所属日期。 -->
          <el-col :span="12">
            <el-form-item prop="shiftDate" label="当班日期">
              <el-date-picker v-model="formData.shiftDate" type="date" value-format="yyyy-MM-dd"
                              placeholder="请选择当班日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isRefining">
            <el-form-item label="生产编号" prop="byzdA2"><el-input v-model="formData.byzdA2" placeholder="留空自动生成生产编号" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="productionDate" label="生产日期">
              <el-date-picker v-model="formData.productionDate" type="date" value-format="yyyy-MM-dd"
                              placeholder="请选择生产日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="配方" prop="productId">
              <el-select v-model="formData.productId" placeholder="请选择配方" @change="loadProductDetail">
                <el-option v-for="(item, index) of productList" :key="index" :label="item.productName"
                           :value="item.productId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="规格型号" prop="specName">
              <el-input v-model="formData.specName" disabled placeholder="选择产品后自动带出" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产线" prop="productionLine">
              <el-input v-model="formData.productionLine" placeholder="请输入生产线" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原料罐" prop="rawMaterialTank">
              <el-input v-model="formData.rawMaterialTank" placeholder="请输入原料罐" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="开罐时间" prop="tankOpeningTime">
              <el-time-picker v-model="formData.tankOpeningTime" value-format="HH:mm:ss"
                              placeholder="请选择开罐时间" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="isRefining ? '批号' : '编号'" prop="recordCode">
              <el-input v-model="formData.recordCode" :placeholder="isRefining ? '请输入批号' : '请输入编号'" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="原料品名" prop="rawMaterialName">
              <el-input v-model="formData.rawMaterialName" placeholder="请输入原料品名" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="原料供应商" prop="rawMaterialSupplier">
              <el-input v-model="formData.rawMaterialSupplier" placeholder="请输入原料供应商" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="实际使用吨位" prop="actualUseTonnage">
              <el-input-number v-model="formData.actualUseTonnage" :min="0" :precision="3"
                               placeholder="请输入实际使用吨位" />
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">-->
<!--            <el-form-item label="储运液位吨位记录" prop="storageTransportLevelTonnageRecord">-->
<!--              <el-input-number v-model="formData.storageTransportLevelTonnageRecord" :min="0" :precision="3"-->
<!--                               controls-position="right" placeholder="请输入储运液位吨位记录" />-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="剩余液位" prop="remainingLevel">-->
<!--              <el-input-number v-model="formData.remainingLevel" :min="0" :precision="3"-->
<!--                               controls-position="right" placeholder="请输入剩余液位" />-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="开机时间" prop="startupTime">
              <el-time-picker v-model="formData.startupTime" value-format="HH:mm:ss"
                              placeholder="请选择开机时间" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="关机时间" prop="shutdownTime">
              <el-time-picker v-model="formData.shutdownTime" value-format="HH:mm:ss"
                              placeholder="请选择关机时间" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="isRefining ? '当班人' : '开机人'" prop="startupOperator">
              <el-input v-model="formData.startupOperator" :placeholder="isRefining ? '请输入当班人' : '请输入开机人'" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="完成数量" prop="recordQuantity">
              <el-input-number v-model="formData.recordQuantity" :min="0" :precision="3"
                               placeholder="请输入完成数量" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isRefining">
            <el-form-item label="入库罐" prop="inboundTank"><el-input v-model="formData.inboundTank" maxlength="200" placeholder="请输入入库罐" /></el-form-item>
          </el-col>
          <el-col :span="12" v-if="isRefining">
            <el-form-item label="入库名称" prop="inboundWarehouseId"><el-select v-model="formData.inboundWarehouseId" filterable placeholder="请选择入库仓库">
                <el-option v-for="item in inboundWarehouseList" :key="item.warehouseId" :label="item.warehouseName" :value="item.warehouseId" />
              </el-select></el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="关联客户" prop="userId">
              <el-select v-model="formData.userId" disabled>
                <el-option :label="item.userName" :value="item.userId" v-for="(item, index) of userList"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!isRefining">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="产品配方" prop="forList">
          <el-table :data="formData.forList"  >
            <el-table-column label="品种规格" prop="specName" show-overflow-tooltip></el-table-column>
            <el-table-column label="本次用量" show-overflow-tooltip>
              <template v-slot="{ row }">{{ formatProductionQuantity(row.consumeQuantity, row.unit) }}</template>
            </el-table-column>
            <el-table-column label="客户" prop="userId" show-overflow-tooltip>
              <template>
                <span>{{ fixedCustomerName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="原材料仓库" prop="warehouseId" show-overflow-tooltip>
              <template v-slot="{ row }">
                <span>{{ rawMaterialWarehouseName(row.warehouseId) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item :label="isRefining ? '产品产出' : '存储仓库'" prop="outList">
          <el-table :data="formData.outList"  >
            <el-table-column label="品种规格" prop="specName" show-overflow-tooltip></el-table-column>
            <el-table-column label="本次产出数量" show-overflow-tooltip>
              <template v-slot="{ row }">{{ formatProductionQuantity(row.outputQuantity, row.unit) }}</template>
            </el-table-column>
            <el-table-column label="仓库" prop="warehouseId" >
              <template v-slot="{ row, $index }">
                <span v-if="isRefining">{{ selectedInboundWarehouseName }}</span>
                <el-form-item v-else :prop="`outList.${$index}.warehouseId`" :rules="[{ required: true, message: '请选择仓库' }]">
                  <el-select v-model="row.warehouseId" filterable>
                    <el-option :label="item.warehouseName" :value="item.warehouseId" v-for="(item) of row.warehouseList"
                               :key="item.warehouseId"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { deepClone } from '@/utils/utils'
import BigNumber from 'bignumber.js'

// 与后端精炼库存流水一致：先精确相乘，再按两位小数四舍五入相除。
const ProductionDecimal = BigNumber.clone({ DECIMAL_PLACES: 2, ROUNDING_MODE: BigNumber.ROUND_HALF_UP })

// 生产库存统一归属于指定客户，新增时不再允许操作人临时切换。
const FIXED_PRODUCTION_CUSTOMER_ID = '20260129134151785480'

// 原材料仓库随产品类型固定；精炼全部产出共用入库名称，包装按产出规格选择仓库。
const RAW_MATERIAL_WAREHOUSE_BY_PRODUCT_TYPE = Object.freeze({
  1: Object.freeze({ warehouseId: '20260512162718129543', warehouseName: '精炼加工原材料仓库' }),
  2: Object.freeze({ warehouseId: '20260512163333155305', warehouseName: '包装生产原材料仓库' })
})

export default {
  name: 'ProductRecordAdd',
  data() {
    return {
      userList: [],
      productList: [],
      inboundWarehouseList: [],
      formData: {
        byzdA2: '',
        inboundTank: '',
        inboundWarehouseId: '',
        productId: '', // 产品id
        productType: '', // 产品类型，用于确定固定的原材料仓库
        specName: '', // 规格型号，选择产品后自动带出
        productionDate: '', // 生产日期
        shiftDate: '', // 当班日期
        productionLine: '', // 生产线
        rawMaterialTank: '', // 原料罐
        tankOpeningTime: '', // 开罐时间
        recordQuantity: undefined, // 完成数量
        userId: FIXED_PRODUCTION_CUSTOMER_ID, // 固定关联客户
        fileList: [], // 附件
        forList: [], // 产品配方列表
        outList: [], // 出库列表
        recordCode: '', // 编号
        rawMaterialName: '', // 原料品名
        rawMaterialSupplier: '', // 原料供应商
        actualUseTonnage: undefined, // 实际使用吨位
        storageTransportLevelTonnageRecord: undefined, // 储运液位吨位记录
        remainingLevel: undefined, // 剩余液位
        startupTime: '', // 开机时间
        shutdownTime: '', // 关机时间
        startupOperator: '' // 开机人
      },
      rules: {
        productId: [{ required: true, message: '请选择配方' }],
        productionDate: [{ required: true, message: '请选择生产日期' }],
        shiftDate: [{ required: true, message: '请选择当班日期' }], // 当班日期必填
        productionLine: [{ required: true, message: '请输入生产线' }],
        rawMaterialTank: [{ required: true, message: '请输入原料罐' }],
        tankOpeningTime: [{ required: true, message: '请选择开罐时间' }],
        recordCode: [{ required: true, message: '请输入编号' }],
        rawMaterialName: [{ required: true, message: '请输入原料品名' }],
        rawMaterialSupplier: [{ required: true, message: '请输入原料供应商' }],
        actualUseTonnage: [{ required: true, message: '请输入实际使用吨位' }],
        // storageTransportLevelTonnageRecord: [{ required: true, message: '请输入储运液位吨位记录' }],
        // remainingLevel: [{ required: true, message: '请输入剩余液位' }],
        startupTime: [{ required: true, message: '请选择开机时间' }],
        shutdownTime: [{ required: true, message: '请选择关机时间' }],
        startupOperator: [{ required: true, message: '请输入开机人' }],
        recordQuantity: [{ required: true, message: '请输入完成数量' }],
        userId: [{ required: true, message: '固定关联客户不能为空' }]
      }
    }
  },
  computed: {
    productType() {
      return this.$route.query.productType || this.formData.productType
    },
    isRefining() {
      return this.productType === '1'
    },
    formRules() {
      return {
        ...this.rules,
        recordCode: [{ required: true, message: this.isRefining ? '请输入批号' : '请输入编号' }],
        startupOperator: [{ required: true, message: this.isRefining ? '请输入当班人' : '请输入开机人' }],
        inboundWarehouseId: [{ required: true, message: '请选择入库名称' }]
      }
    },
    refiningOutputBase() {
      if (!this.formData.outList.length) return null
      let maximum = new ProductionDecimal(0)
      for (const output of this.formData.outList) {
        if (output.outputQuantity === null || output.outputQuantity === undefined || output.outputQuantity === '') return null
        const quantity = new ProductionDecimal(output.outputQuantity)
        if (!quantity.isFinite() || quantity.lt(0)) return null
        if (quantity.gt(maximum)) maximum = quantity
      }
      return maximum.gt(0) ? maximum : null
    },
    selectedInboundWarehouseName() {
      const warehouse = this.inboundWarehouseList.find(item => item.warehouseId === this.formData.inboundWarehouseId)
      return warehouse ? warehouse.warehouseName : '请先选择入库名称'
    },
    fixedCustomerName() {
      const customer = this.userList.find(item => item.userId === FIXED_PRODUCTION_CUSTOMER_ID)
      return customer ? customer.userName : FIXED_PRODUCTION_CUSTOMER_ID
    }
  },
  created() {
    this.loadUserList()
    this.loadProductList()
    this.loadInboundWarehouseList()
  },
  methods: {
    formatProductionQuantity(formulaQuantity, unit) {
      const quantity = this.productionQuantity(formulaQuantity)
      return quantity === '-' || !unit ? quantity : `${quantity} ${unit}`
    },
    productionQuantity(formulaQuantity) {
      const completedQuantity = this.formData.recordQuantity
      if ([formulaQuantity, completedQuantity].some(value => value === null || value === undefined || value === '')) return '-'
      const formula = new ProductionDecimal(formulaQuantity)
      const completed = new ProductionDecimal(completedQuantity)
      if (!formula.isFinite() || !completed.isFinite() || formula.lt(0) || completed.lt(0)) return '-'
      const quantity = formula.times(completed)
      if (!this.isRefining) return quantity.toFixed()
      return this.refiningOutputBase ? quantity.div(this.refiningOutputBase).toFixed(2) : '-'
    },
    loadProductList() {
      this.$axios.get(this.$apis.prodManage.selectScProductByPage, { productType: this.productType, page: 1, size: 9999 }).then(res => {
        this.productList = res.list
      })
    },
    loadProductDetail(productId) {
      // 切换配方时清空旧明细，避免等待新响应期间显示上一配方的计算结果。
      this.formData.forList = []
      this.formData.outList = []
      return this.$axios.get(this.$apis.prodManage.selectScProductByProductId, {
        params: { productId }
      }).then(res => {
        if (productId !== this.formData.productId) return
        const warehouseConfig = RAW_MATERIAL_WAREHOUSE_BY_PRODUCT_TYPE[res.productType]
        if (!warehouseConfig) {
          this.$message.error('当前产品类型未配置原材料仓库')
          this.formData.forList = []
          this.formData.outList = []
          return
        }

        // 产品决定规格与原材料仓库，客户统一使用前端固定配置。
        this.formData.productType = res.productType
        this.formData.specName = res.specName
        this.formData.userId = FIXED_PRODUCTION_CUSTOMER_ID
        this.formData.forList = (res.forList || []).map(item => {
          return {
            specId: item.specId,
            specName: item.specName,
            unit: item.unit,
            consumeQuantity: item.consumeQuantity,
            userId: FIXED_PRODUCTION_CUSTOMER_ID,
            warehouseId: warehouseConfig.warehouseId
          }
        })
        this.formData.outList = (res.outList || []).map(item => {
          return {
            specId: item.specId,
            specName: item.specName,
            unit: item.unit,
            outputQuantity: item.outputQuantity,
            warehouseId: '',
            managerType: item.isBulkOil === '1' ? '1' : '2',
            warehouseList: []
          }
        })
        if (!this.isRefining) {
          this.formData.outList.forEach(item => this.loadWarehouseList(item))
        }
      })
    },
    rawMaterialWarehouseName(warehouseId) {
      const productType = Object.keys(RAW_MATERIAL_WAREHOUSE_BY_PRODUCT_TYPE).find(type => {
        return RAW_MATERIAL_WAREHOUSE_BY_PRODUCT_TYPE[type].warehouseId === warehouseId
      })
      return productType ? RAW_MATERIAL_WAREHOUSE_BY_PRODUCT_TYPE[productType].warehouseName : warehouseId
    },
    loadInboundWarehouseList() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage, { page: 1, size: 9999 }).then(res => {
        this.inboundWarehouseList = res.list || []
      })
    },
    loadWarehouseList(row) {
      console.log('rowrow', row)
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage, {
        managerType: row.managerType
      }).then(res => {
        row.warehouseList = res.list.map(item => {
          return {
            warehouseId: item.warehouseId,
            warehouseName: item.warehouseName
          }
        })
      })
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2,3,4',
        page: 1,
        size: 999
      }).then(res => {
        this.userList = res.list
      })
    },
    loadDetails() {
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByWarehouseId, {
        params: { warehouseId: this.warehouseId }
      }).then(res => {
        this.formData = res
      })
    },
    submit() {
      this.$refs.formData.validate().then(() => {
        const url = this.$apis.prodManage.insertScProRecord
        const formData = deepClone(this.formData)
        const warehouseConfig = RAW_MATERIAL_WAREHOUSE_BY_PRODUCT_TYPE[formData.productType]
        if (!warehouseConfig) {
          this.$message.error('当前产品类型未配置原材料仓库')
          return
        }
        // 提交前再次覆盖固定值，确保页面状态变化不会把仓库或客户带偏。
        formData.userId = FIXED_PRODUCTION_CUSTOMER_ID
        formData.forList.forEach(item => {
          item.userId = FIXED_PRODUCTION_CUSTOMER_ID
          item.warehouseId = warehouseConfig.warehouseId
        })
        formData.outList.forEach(item => {
          if (this.isRefining) item.warehouseId = formData.inboundWarehouseId
          delete item.warehouseList
          delete item.managerType
        })
        delete formData.productType
        this.$axios.post(url, formData).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>

.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader,
.el-input-number,
.el-date-editor {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {
  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
